import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { Spin } from "antd";
import { canAccessUserManagement } from "../utils/roleUtils";
import { isDashmoteStaffEmail } from "../slices/authSlice";

// Allow access if user is a dashmote email OR has an admin-level role in the current workspace
const UserManagementProtectedRoute = ({ children }) => {
  const { user, userData, selectedWorkspace, loading, isInitialized } = useSelector((state) => state.auth);

  // Allow access for all dashmote.com emails (including demo accounts). Checked
  // before the loading gate so a dashmote user is never held on the spinner.
  if (isDashmoteStaffEmail(user?.email)) {
    return children;
  }

  // Wait for auth to initialize and userData to load before making access decision.
  // Without this, the route redirects to "/" while userData is still being fetched,
  // making the page appear to "stick" on the current page for valid admin users.
  if (!isInitialized || (loading && !userData)) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <Spin size="large" />
      </div>
    );
  }

  // Same predicate the profile-dropdown nav items use, so the menu can never
  // surface a link this guard would redirect away from.
  if (canAccessUserManagement(user?.email, userData, selectedWorkspace)) {
    return children;
  }

  return <Navigate to="/" replace />;
};

export default UserManagementProtectedRoute;
